export const GET_MANAGERS_LIST = 'GET_MANAGERS_LIST';
export const GET_MANAGERS_LIST_SUCCESS = `${GET_MANAGERS_LIST}_SUCCESS`;
export const CREATE_MANAGER_SUCCESS = 'CREATE_MANAGER_SUCCESS';
export const DELETE_MANAGER = 'DELETE_MANAGER';
export const DELETE_MANAGER_SUCCESS = `${DELETE_MANAGER}_SUCCESS`;
